import {RequestAnfrage} from "../../model/request.anfrage";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";
import {Optimierung} from "../interfaces/configuration";
import {Result} from "../interfaces/result";
import {System} from "typescript";

/**
 * Class holds all the data of the request inside the photovoltaikcheck that the user needs for the frontend.
 */
export class PhotovoltaikcheckAnfrage implements RequestAnfrage {

  /**
   * Different path
   */
  public static readonly PATH_BALCONY =  'balkon';
  public static readonly PATH_ALL = 'all';

  /**
   * holding the path that the user takes
   */
  path: string;

  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string = null;

  /**
   * path of the user
   */
  interesse: string = null;

  /**
   * Input of the user
   */
  userInput: any = {};

  /**
   * The last configuration that the user selected
   */
  configurationSelected: Optimierung = null;

  /**
   * result of the user's dialog registration
   */
  dialogResult: string = null;

  /**
   * Holds the result from the calculation
   */
  result: Result = {};

  /**
   * @inheritdoc
   */
  campaignId: string;

  /**
   * @inheritdoc
   */
  lastPath: string;

  /**
   * The given adress of the map
   */
  mapAddress?: string = null;

  /**
   * list of polygons of the map.
   */
  mapPolygons?: string = null;

  /**
   * living area for the calculation of the available roof area
   */
  livingArea?: number = null;

  /**
   * number of floors for the calculation of the available roof area
   */
  floors?: number = null;

  /**
   * Get the maximum consumption input for this request.
   */
  getMaxConsumption(): number {
    let max = PhotovoltaikcheckConstants.VALIDATE_CONSUMPTION;
    if(this.userInput?.waermepumpe === 'vorhanden') {
      max += PhotovoltaikcheckConstants.VALIDATE_CONSUMPTION_PUMP;
    }
    if(this.userInput?.elektroauto === 'vorhanden') {
      max += PhotovoltaikcheckConstants.VALIDATE_CONSUMPTION_ECAR;
    }
    return max;
  }
}
